import React from 'react';
import SyncSectionCheckbox from '../sync-section-checkbox';
import { Toggle } from 'material-ui';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import Dates from './dates';
import StayPays from '../../../generic-components/staypay';
import DaysOfWeek from '../../../generic-components/days-of-week';
import debounce from 'lodash.debounce';
import R, { path } from 'ramda';
import moment from 'moment';
const propTypes = {
  data: React.PropTypes.object,
  contractingPeriod: React.PropTypes.object,
  contractId: React.PropTypes.string,
  productId: React.PropTypes.string,
  saving: React.PropTypes.bool,
  onTextFieldChangeWithKeyPath: React.PropTypes.func,
  updateDaysOfWeek: React.PropTypes.func,
  onRequestClose: React.PropTypes.func,
  saveProductInfoChanges: React.PropTypes.func,
  goToStep: React.PropTypes.func,
};

const StepOneStayPayOfferWizard = props => {
  const { data, onTextFieldChangeWithKeyPath, updateDaysOfWeek, goToStep, contractingPeriod } = props;
  const validDatesOfTravel = data.validDatesOfTravel.filter(dateSet => dateSet.fromDate || dateSet.toDate);
  const validDatesOfSale = data.validDatesOfSale.filter(dateSet => dateSet.fromDate || dateSet.toDate);
  const checkRequiredField = () => {
    const { stayPays, bookingCode, daysOfWeek } = data;
    const stayPaysEmpty = stayPays.every(stayPay => !(stayPay.stayDays && stayPay.payDays));
    const validDatesOfTravelEmpty = R.isEmpty(validDatesOfTravel);
    const validDatesOfSaleEmpty = R.isEmpty(validDatesOfSale);
    const daysOfWeekEmpty = R.isEmpty(daysOfWeek);
    if (stayPaysEmpty || !bookingCode || validDatesOfSaleEmpty || validDatesOfTravelEmpty || daysOfWeekEmpty) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'generalError'], value: 'Please fill all required fields.' });
      debounce(() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'generalError'], value: '' }), 3000)();
      return false;
    }
    return true;
  };
  const checkStayPayValidity = () => {
    const { stayPays } = data;
    if (stayPays.every(stayPay => !(stayPay.stayDays && stayPay.payDays))) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: 'Please enter at least one set of Stay Pay rule.' });
      debounce(() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: '' }), 3000)();
      return false;
    }
    if (stayPays.some(stayPay => stayPay.stayDays < stayPay.payDays)) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: 'Stay Days have to be more than Pay Days.' });
      debounce(() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: '' }), 3000)();
      return false;
    }
    if (stayPays.some(stayPay => !stayPay.maxFOC)) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: 'Maximum FOC nights is required.' });
      debounce(() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: '' }), 3000)();
      return false;
    }
    return true;
  };
  return (
    <div>
      <div style={{ padding: '24px 12px 0', overflow: 'inherit' }}>
        <div style={{ fontSize: '12px', color: 'red' }}>{data.generalError}</div>
        <TwoColumnRow
          leftColumnStyle={{ position: 'relative', top: '10px', fontSize: '16px', width: '45%' }}
          leftColumnContent={
            <div>
              Please enter a booking code that the agent should include at the time of booking.
              <div style={{ fontSize: '12px', color: '#ff4081' }}>* Required</div>
            </div>
          }
          rightColumnStyle={{ width: '48%' }}
          rightColumnContent={
            <TypeControlledTextField
              style={{ width: '100%', position: 'relative', top: '-20px' }}
              value={data.bookingCode}
              floatingLabelText="Booking Code"
              onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'bookingCode'], value })}
            />
          }
        />
        <Dates
          data={data}
          disableSalesDates
          contractingPeriod={contractingPeriod}
          onTextFieldChangeWithKeyPath={onTextFieldChangeWithKeyPath}
        />
        <TwoColumnRow
          leftColumnStyle={{ fontSize: '16px', width: '45%', display: 'flex', justifyContent: 'space-between' }}
          leftColumnContent={
            <div>
              Which day(s) of the week does this offer apply to?
              <span style={{ fontSize: '12px', color: '#ff4081' }}>* Required</span>
            </div>
          }
          rightColumnStyle={{ width: '48%' }}
          rightColumnContent={
            <DaysOfWeek
              daysOfWeek={data.daysOfWeek}
              updateDaysOfWeek={(checked, day, dayIndexInReducer) => updateDaysOfWeek({ checked, day, dayIndexInReducer })}
            />
          }
        />
        <TwoColumnRow
          outerContainerStyle={{ height: '104px', display: 'flex', justifyContent: 'space-between' }}
          leftColumnStyle={{ fontSize: '16px', width: '45%' }}
          leftColumnContent={
            <div>
              Please note the details of this special offer. For example, when room upgrades are processed (at booking or check-in), buy one get one free, etc.
            </div>}
          rightColumnStyle={{ width: '48%', height: '104px', overflowY: 'scroll' }}
          rightColumnContent={
            <TypeControlledTextField
              style={{ width: '100%', position: 'relative', top: '-10px' }} multiLine
              floatingLabelText="Offer Details"
              value={data.offerDetail}
              onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerDetail'], value })}
            />
          }
        />
        <TwoColumnRow
          outerContainerStyle={{ height: '68px', display: 'flex', justifyContent: 'space-between' }}
          leftColumnStyle={{ position: 'relative', top: '20px', fontSize: '16px', width: '45%' }}
          leftColumnContent="Please enter any special conditions for this offer, if needed."
          rightColumnStyle={{ width: '48%', height: '84px', overflowY: 'scroll' }}
          rightColumnContent={
            <TypeControlledTextField
              style={{ width: '100%', position: 'relative', top: '-10px' }} multiLine
              floatingLabelText="Special Conditions"
              value={data.specialConditions}
              onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'specialConditions'], value })}
            />
          }
        />
        <div style={{ width: '100%', paddingLeft: '10%' }}>
          <StayPays
            defaultYes
            staypayApplicable="yes"
            stayPayError={data.stayPayError}
            stayPays={data.stayPays}
            updateFieldValue={(key, value) => onTextFieldChangeWithKeyPath({ keyPath: ['data', key], value })}
          />
        </div>
        <TwoColumnRow
          outerContainerStyle={{ height: '68px', display: 'flex', justifyContent: 'space-between', marginBottom: 0 }}
          leftColumnStyle={{ position: 'relative', top: '20px', fontSize: '16px', width: '45%' }}
          leftColumnContent="Is this special offer allowed to be combined with other special offers?"
          rightColumnStyle={{ width: '48%', height: '48px' }}
          rightColumnContent={
            <div style={{ position: 'relative', top: '20px' }}>
              <Toggle
                style={{ display: 'inline-block', width: '60px' }}
                toggled={data.allowCombination}
                onToggle={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'allowCombination'], value: !data.allowCombination })}
              />
            </div>}
        />
      </div>
      <div style={{ width: '95%', margin: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <FlatButton
          secondary
          label={'Back'}
          onTouchTap={() => onTextFieldChangeWithKeyPath({ keyPath: ['data'], value: R.omit(['isStayPay', data]) })}
          labelStyle={{ fontWeight: '600' }}
        />
        <div style={{ fontSize: '12px', color: 'red' }}>{data.generalError}</div>
        <FlatButton
          secondary
          label="Continue"
          onTouchTap={() => {
            if (checkRequiredField() && checkStayPayValidity()) goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 1 });
          }}
          labelStyle={{ fontWeight: '600' }}
        />
      </div>
    </div>
  );
};
StepOneStayPayOfferWizard.propTypes = propTypes;
export default StepOneStayPayOfferWizard;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/1-step-staypay-offers.jsx